export const DiscountSource = {
  ACCOUNT: 'account',
  DISCOUNT_FORM: 'discount-form'
};

export const RewardsPageComponents = {
  REWARDS: 'rewards',
  MEMBERSHIP: 'membership',
  POINTS_BALANCE: 'pointsBalance',
  STAMPS: 'stamps',
  FRIEND_REFERRAL: 'friendReferral',
  HOW_IT_WORKS: 'howItWorks',
  TIERS: 'tiers',
  POINTS_HISTORY: 'pointsHistory',
};

export const defaultRewardsPageComponentsOrder = [
  RewardsPageComponents.REWARDS,
  RewardsPageComponents.MEMBERSHIP,
  RewardsPageComponents.POINTS_BALANCE,
  RewardsPageComponents.STAMPS,
  RewardsPageComponents.FRIEND_REFERRAL,
  RewardsPageComponents.HOW_IT_WORKS,
  RewardsPageComponents.TIERS,
  RewardsPageComponents.POINTS_HISTORY,
];